/* Copyright (c) 2018 Verge Technologies
 * @file applicationCard.js
 * @author Brenton Watt
 * @description Card component for applications for Seperations
 */

import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

const ApplicationCard = (props) => {
  return (
    <li>
      <div className="content">
        {props.iconImage && <img src={props.iconImage} alt="application"/>}
        {!props.iconImage && <svg viewBox="0 0 55.967 55.967">
          <g transform="translate(13223.5 18947.501)">
            <rect
              fill="none"
              stroke="#FFFFFF"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeMiterlimit="10"
              strokeWidth="3px"
              width="52.967"
              height="52.967"
              transform="translate(-13222 -18946)"
            />
            <path
              fill="none"
              stroke="#FFFFFF"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeMiterlimit="10"
              strokeWidth="3px"
              d="M64.286,49.876H57.042L52.051,28.142,47.06,49.876H42.874l-4.991-16.5-4.991,16.5H28.626L23.635,21.3,18.645,49.876H11.4"
              transform="translate(-13233.4 -18956.111)"
            />
          </g>
        </svg>}
        <h3 style={{ color: 'white', fontWeight: 'bold' }}>{props.title}</h3>
        <Link
          to={{
            pathname: '/products',
            search: "?applications",
            hash: props.id,
          }}
          className="button"
        >
          View more
        </Link>
      </div>
      <div className="banner" style={{ backgroundImage: `url(${props.backgroundImage})` }} />
      <div className="banner overlay" />
    </li>
  );
};

ApplicationCard.propTypes = {
  title: PropTypes.string.isRequired,
  backgroundImage: PropTypes.string.isRequired,
  iconImage: PropTypes.string.isRequired,
};

export default ApplicationCard;



// WEBPACK FOOTER //
// ./src/components/ApplicationCard/applicationCard.js